import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const BrandingContext = createContext();

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error('useBranding must be used within a BrandingProvider');
  }
  return context;
};

export const BrandingProvider = ({ children }) => {
  const { user } = useAuth();
  const [brandTitle, setBrandTitle] = useState('FieldHouse');
  const [brandLogo, setBrandLogo] = useState(null);

  const fetchBranding = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const response = await axios.get('/api/organizations/my-organizations', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const orgUsers = Array.isArray(response.data) ? response.data : [];
      const primaryOrg = orgUsers.find((ou) => ou?.is_primary) || orgUsers[0];
      const orgName = primaryOrg?.Organization?.name || primaryOrg?.name;
      const logo = primaryOrg?.Organization?.logo || primaryOrg?.logo || null;

      if (orgName && String(orgName).trim()) {
        setBrandTitle(String(orgName).trim());
      }
      setBrandLogo(logo);
    } catch {
      // Keep default branding when org data is unavailable
    }
  }, []);

  useEffect(() => {
    fetchBranding();
  }, [user?.id, fetchBranding]);

  return (
    <BrandingContext.Provider value={{ brandTitle, brandLogo, refetchBranding: fetchBranding }}>
      {children}
    </BrandingContext.Provider>
  );
};
